import { motion } from "framer-motion";

const shots = [
  {
    src: "https://images.unsplash.com/photo-1682888813913-e13f18692019?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    alt: "Sparkling marble kitchen island",
    cls: "md:col-span-2 md:row-span-2",
  },
  {
    src: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Bright, tidy living room",
    cls: "",
  },
  {
    src: "https://images.unsplash.com/photo-1631048501786-4e97f20eac71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    alt: "Wide view of a bright, freshly made bedroom",
    cls: "",
  },
  {
    src: "https://images.unsplash.com/photo-1502005097973-6a7082348e28?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    alt: "Clean white kitchen with island",
    cls: "md:col-span-2",
  },
];

const ease = [0.16, 1, 0.3, 1];

export default function Gallery() {
  return (
    <section id="gallery" className="px-6 py-24 md:py-36" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease }}
            className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-xl"
          >
            Spaces we've made <span className="italic text-[#C1440E]">shine</span>
          </motion.h2>
          <p className="text-[#5A2E14] max-w-sm text-base">
            A peek at the kind of clean we deliver — every corner, every time.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[220px] md:auto-rows-[300px] gap-4">
          {shots.map((s, i) => (
            <motion.figure
              key={i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease }}
              className={`group relative overflow-hidden rounded-3xl border border-[#C68A3A] ${s.cls}`}
            >
              <img
                src={s.src}
                alt={s.alt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#241B2E]/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
